import React from "react";
import * as ReactDOMLegacy from "react-dom";
import { createRoot } from "react-dom/client";
import "./styles.css";

// The design-system bundle is a browser global build that reads window.React /
// window.ReactDOM at load time. Publishing this app's single React instance to
// those globals means the DS components and the app share one React (no
// duplicate-renderer hook errors), and the UI renders identically to the
// approved prototype.
(window as any).React = React;
(window as any).ReactDOM = { ...(ReactDOMLegacy as any), createRoot };

function loadDesignSystem(): Promise<void> {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = import.meta.env.BASE_URL + "ds/_ds_bundle.js";
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Failed to load the design-system bundle"));
    document.head.appendChild(s);
  });
}

// App is imported *after* the bundle loads, because the screens read the DS
// components from window.ArcRunDS at module scope.
loadDesignSystem()
  .then(() => import("./App"))
  .then(({ default: App }) => {
    createRoot(document.getElementById("root")!).render(<App />);
  })
  .catch((err) => {
    document.getElementById("root")!.textContent = String(err && err.message ? err.message : err);
  });
